import { defineStore } from 'pinia';
import MetaCampaignsAdSetsAPI from 'dashboard/api/metaCampaignsAdSets';
import MetaCampaignsAdsAPI from 'dashboard/api/metaCampaignsAds';

// Ad set / ad breakdown for a single campaign (the "Conjuntos" and
// "Anúncios" tabs). Separate from metaCampaignsCampaigns.js since the two
// tabs share a campaign and period but fetch independently, on first
// activation rather than on page mount.
export const useMetaCampaignsCampaignBreakdownStore = defineStore(
  'metaCampaignsCampaignBreakdown',
  {
    state: () => ({
      adSets: null,
      ads: null,
      uiFlags: {
        fetchingAdSets: false,
        fetchingAds: false,
      },
    }),

    actions: {
      async fetchAdSets(campaignId, params = {}) {
        this.uiFlags.fetchingAdSets = true;
        try {
          const { data } = await MetaCampaignsAdSetsAPI.get(campaignId, params);
          this.adSets = data;
        } finally {
          this.uiFlags.fetchingAdSets = false;
        }
      },

      async fetchAds(campaignId, params = {}) {
        this.uiFlags.fetchingAds = true;
        try {
          const { data } = await MetaCampaignsAdsAPI.get(campaignId, params);
          this.ads = data;
        } finally {
          this.uiFlags.fetchingAds = false;
        }
      },
    },
  }
);
